import { render, staticRenderFns } from "./LectureAccount.vue?vue&type=template&id=03e678a6&scoped=true&"
import script from "./LectureAccount.vue?vue&type=script&lang=js&"
export * from "./LectureAccount.vue?vue&type=script&lang=js&"
import style0 from "./LectureAccount.vue?vue&type=style&index=0&id=03e678a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e678a6",
  null
  
)

export default component.exports